/**
 * Created by Delin on 2021/07/23.
 * 加载中、上传中状态管理
 */
const defaultLoadingMsg = '努力加载中. . .'
const defaultUploadingMsg = '正在上传中. . .'

const loading = {
  namespaced: true,
  state: {
    loading: false,
    loadingMsg: null,
    uploading: false,
    uploadingMsg: null,
    uploadingProgress: 0
  },
  mutations: {
    showLoading (state, msg) {
      state.loadingMsg = msg || defaultLoadingMsg
      state.loading = true
    },
    loading (state, loading) {
      state.loadingMsg = defaultLoadingMsg
      state.loading = loading
    },
    showUploading (state, msg) {
      state.uploadingMsg = msg || defaultUploadingMsg
      state.uploading = true
    },
    uploading (state, uploading) {
      state.uploadingMsg = defaultUploadingMsg
      state.uploading = uploading
    },
    uploadingProgress (state, progress) {
      state.uploadingProgress = progress
    },
  }
}
export default loading
